import React from "react";
import { getPageSetting } from "tsi-common-react/src/utils/settings";

// The basket-summary help box shared by the basket and checkout sidebars
// (BasketAppInner + CheckoutAppInner both render it). The phone number is read
// from page settings at render time.
export const BasketSidebarContent = (): React.JSX.Element => (
    <div className="basket-summary__help">
        {/* TODO(i18n): Use t tagged template: {t`Questions?`} */}
        <h3>Questions?</h3>
        <p className="basket-summary__text">
            {/* TODO(i18n): Use t with interpolation to keep sentence together: {t`Call ${phoneLink}.`} */}
            Call{" "}
            <a
                className="basket-summary__phone-link"
                href={getPageSetting("pre_order_phone_number_link") || ""}
            >
                {getPageSetting("pre_order_phone_number_display") || ""}
            </a>
            .
        </p>
    </div>
);
